const ThankYou = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-blue-50 text-center p-8">
      <h1 className="text-4xl font-bold text-blue-700 mb-4">Thank You!</h1>
      <p className="text-gray-600 text-lg">Your message has been sent successfully. I’ll be in touch soon!</p>
    </div>
  );
};

export default ThankYou;
